import { MedSummaryReference } from './schemas'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type MedSummaryReferencesRecord = { [reference_id: string]: MedSummaryReference }

export type MedSummaryReferencesState = {
  // Keyed by parent id: a legacy job id or a living-asset id (both UUIDs, never colliding)
  references: { [parentId: string]: MedSummaryReferencesRecord }
}

const initialState: MedSummaryReferencesState = {
  references: {},
}

export const medSummaryReferencesSlice = createSlice({
  name: 'medSummaryReferencesState',
  initialState,
  reducers: {
    nullifyData: () => initialState,

    setReferencesRecord: (state, action: PayloadAction<{ parentId: string; references: MedSummaryReferencesRecord }>) => {
      state.references[action.payload.parentId] = action.payload.references
    },
  },
})

// Actions
export const MedSummaryReferencesActions = medSummaryReferencesSlice.actions

export default medSummaryReferencesSlice.reducer
